var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        clearable: "",
        filterable: "",
        placeholder: "Sélection",
        size: "mini",
        disabled: _vm.disabled
      },
      on: {
        change: function($event) {
          return _vm.onChange($event)
        },
        clear: function($event) {
          return _vm.onClear()
        }
      },
      model: {
        value: _vm.idCommande,
        callback: function($$v) {
          _vm.idCommande = $$v
        },
        expression: "idCommande"
      }
    },
    _vm._l(_vm.commandes, function(item) {
      return _c(
        "el-option",
        { key: item.id, attrs: { label: item.numero, value: item.id } },
        [
          _c("span", { staticStyle: { float: "left" } }, [
            _vm._v(_vm._s(item.numero))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                float: "right",
                color: "#8492a6",
                "font-size": "13px",
                "font-style": "italic"
              }
            },
            [_vm._v(" " + _vm._s(_vm._f("toDate")(item.date_commande)))]
          )
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }